import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Carousel } from 'primereact/carousel';
import BaseCard from './BaseCard.jsx';
import { useNavigate } from 'react-router-dom';

const OrganizationContactsCarousel = ({ className, items, page, orgId }) => {
    const navigate = useNavigate();

    const contactItemTemplate = (contact) => {
        let company = contact.companies.find((company) => company.organization_id === orgId);
        return (
            <div className='mr-4'>
                <BaseCard
                    className='mr-4 my-4 p-4 relative rounded-2xl min-h-[80px] shadow-mildSubtleRight'
                    onClick={() => navigate('/contacts/view/' + contact.id)}
                >
                    <div className='flex items-center justify-center'>
                        <div className='rounded-full w-20 h-20 overflow-hidden'>
                            {contact.avatar ? (
                                <img src={contact.avatar} alt='Avatar' />
                            ) : (
                                <div className='w-full h-full bg-theme1-pale flex items-center justify-center'>
                                    <div className='text-theme1-primary font-bold text-3xl'>
                                        {`${contact.first_name?.[0]?.toUpperCase() || ''}${
                                            contact.last_name?.[0]?.toUpperCase() || ''
                                        }`}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='text-theme1-primary font-bold text-md mt-2'>
                        {[contact.first_name, contact.middle_name, contact.last_name].filter(Boolean).join(' ')}
                    </div>
                    <div className='mt-1 text-sm font-bold text-theme1-text2'>{company.job_title || '-'}</div>
                </BaseCard>
            </div>
        );
    };

    return (
        <div className={twMerge('', className)}>
            <Carousel
                value={items}
                numScroll={1}
                numVisible={2}
                itemTemplate={contactItemTemplate}
                showNavigators={false}
                circular={false}
                showIndicators
                page={page || 0}
            />
        </div>
    );
};

export default OrganizationContactsCarousel;
